import { z } from 'zod';
import { ThreadSubjectType } from '../enums';

export const ThreadQuerySchema = z.object({
  subject_type: z.nativeEnum(ThreadSubjectType),
  subject_id: z.string().uuid(),
});

export const CreateThreadMessageSchema = z.object({
  subject_type: z.nativeEnum(ThreadSubjectType),
  subject_id: z.string().uuid(),
  body: z.string().min(1, 'Message cannot be empty').max(10000),
  mentions: z.array(z.string().uuid()).default([]),
});

export const MentionableQuerySchema = z.object({
  q: z.string().max(100).optional(),
});

export type ThreadQuery = z.infer<typeof ThreadQuerySchema>;
export type CreateThreadMessage = z.infer<typeof CreateThreadMessageSchema>;
export type MentionableQuery = z.infer<typeof MentionableQuerySchema>;
